import { FunctionComponent, ReactNode } from "react";

/** The muted centre line between messages ("Ticket received", "Status changed" + pill). */
export const TicketSystemLine: FunctionComponent<{ children: ReactNode }> = ({ children }) => (
	<div className="flex items-center gap-2 py-1 text-xs text-text-meta">
		{children}
		<span className="h-px flex-1 bg-border" />
	</div>
);
